import * as http from "./base";

const prefix = "/billing";

export async function fetchBillingInfo() {
  return await http.get(`${prefix}-credit-cards`);
}

export async function fetchCreditCard(id) {
  return await http.get(`${prefix}-credit-cards/?card_id=${id}`);
}

export async function createCreditCard(data) {
  return await http.post(`${prefix}-credit-cards`, data);
}

export async function fetchInvoices({
  page,
  sort,
  search,
  page_size,
  queryString
}) {
  const qs = http.prepareQueryString({
    page,
    sort,
    search,
    page_size,
    queryString
  });

  return await http.get(`${prefix}-invoices-list/?${qs}`);
}

export async function fetchPrimaryCard() {
  return await http.get(`${prefix}-default-payment-method`);
}

export async function fecthSubscription() {
  return await http.get(`${prefix}-subscription-retrieve`);
}

export async function cancelSubscription() {
  return await http.del(`${prefix}-subscription-cancel`);
}

export async function resumeSubscription() {
  return await http.put(`${prefix}-subscription-resume`);
}

export async function upgradeSubscription(planId) {
  return await http.post(`${prefix}-subscription-upgrade`, { plan_id: planId });
}

export async function downgradeSubscription(planId) {
  return await http.post(`${prefix}-subscription-downgrade`, {
    plan_id: planId
  });
}

export async function fetchBillingHistory() {
  return await http.get(`${prefix}`);
}

export async function removeCreditCard(id) {
  return await http.del(`${prefix}-credit-cards/${id}`);
}

export async function setPrimaryCard(id) {
  return await http.put(`${prefix}-default-payment-method`, {
    card_or_bank_id: id
  });
}

export async function savePlaid(token, account_id) {
  return await http.post(`${prefix}-bank-accounts`, {
    plaid_token: token,
    plaid_bank_account_id: account_id
  });
}

export async function fetchBankAccounts() {
  return await http.get(`${prefix}-bank-accounts`);
}

export async function fetchBankAccount(id) {
  return await http.get(`${prefix}-bank-accounts/?bank_account_id=${id}`);
}

export async function fetchSubscriptionsPlansInfo() {
  return await http.get(`/subscription-plans-list`);
}
